import { graphql } from '@/gql';
import type { DownloadNumberOfRidesTakenPerUserQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const downloadNumberOfRidesTakenPerUser = async ({
  callerName,
  status,
  startDate,
  endDate,
  partnerId,
}: DownloadNumberOfRidesTakenPerUserQueryVariables): Promise<string> => {
  const response = await queryExecute({
    query: graphql(`
      query DownloadNumberOfRidesTakenPerUser(
        $partnerId: Float!
        $callerName: String
        $status: String
        $startDate: String
        $endDate: String
      ) {
        downloadNumberOfRidesTakenPerUser(
          partnerId: $partnerId
          callerName: $callerName
          status: $status
          startDate: $startDate
          endDate: $endDate
        )
      }
    `),
    variables: {
      callerName,
      status,
      startDate,
      endDate,
      partnerId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data?.downloadNumberOfRidesTakenPerUser;
};
